import { createContext, useContext, useEffect, useState } from "react";
import { apiGetMyUsers } from "services";
import { IAdminUsers } from "types/userTypes";

interface UsersContextType {
    users: IAdminUsers[];
    setUsers: React.Dispatch<React.SetStateAction<IAdminUsers[]>>;
}

const UsersContext = createContext<UsersContextType | undefined>(undefined);

export const UsersProvider = ({ children }: { children: React.ReactNode }) => {
    const [users, setUsers] = useState<IAdminUsers[]>([]);

    useEffect(() => {
        const fetchMyUsers = async () => {
            try {
                const response = await apiGetMyUsers();
                setUsers(response);
            } catch (err) {
                console.error(err);
            }
        };
        fetchMyUsers();
    }, []);

    return (
        <UsersContext.Provider value={{ users, setUsers }}>
            {children}
        </UsersContext.Provider>
    );
};

export const useUsers = () => {
    const context = useContext(UsersContext);
    if (!context) {
        throw new Error("useUsers must be used within a UsersProvider");
    }
    return context;
};
